










































































































































































// @ts-nocheck
import { DagreDirected } from '@/assets/bpchart/main.js'
import * as apis from '@/apis/index.ts'
import utils from '@/utils/utils.js'
import * as screenImageGetter from '@/utils/screenImageGetter.ts'
import * as ChartCardTypes from '@/assets/bpchart/types/charts/dagreDirectedChartCard.ts'
import * as ChartTypes from '@/assets/bpchart/types/components/dagreDirectedChart.ts'
import DagreDirectedChart from './DagreDirectedChart.vue'
import CompanySummaryLightbox from '@/components/CompanySummaryLightbox/CompanySummaryLightbox.vue'

const defaultTitle = '法人董事'

const cardStyle = {
  width: 'auto',
  height: 'auto',
  'padding-top': 16,
  'padding-right': 20,
  'padding-bottom': 5,
  'padding-left': 20,
  header: {
    height: 85
  },
  footer: {
    height: 25,
    logo: {
      // height: 25
    }
  }
}

// const logoSvgBase64 = 'data:image/png;base64,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'
// const logoSvgBase64 = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNzkuOTIgMTAwLjYxIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzE3NzhmNTt9LmNscy0ye2ZpbGw6IzdmYjVmOTt9LmNscy0ze2ZpbGw6I2ZmZDIwMDt9LmNscy00e2ZpbGw6bm9uZTtzdHJva2U6IzMwNmRiNDtzdHJva2UtbWl0ZXJsaW1pdDoxMDtzdHJva2Utd2lkdGg6MC41cHg7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT7os4fnlKIgMTwvdGl0bGU+PGcgaWQ9IuWcluWxpF8yIiBkYXRhLW5hbWU9IuWcluWxpCAyIj48ZyBpZD0i5ZyW5bGkXzEtMiIgZGF0YS1uYW1lPSLlnJblsaQgMSI+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMTY2LjM4LDM0LjMzSDE0NS43MnYxNS40aDQuNTFWNDcuODJoMTYuMTV2MS45MWg0LjUxVjM0LjMzWm0wLDkuNDlIMTUwLjIzdi01LjVoMTYuMTVaIi8+PHBvbHlnb24gY2xhc3M9ImNscy0xIiBwb2ludHM9IjE3My4wOSAyNy40MSAxNjAuNjUgMjcuNDEgMTYwLjY1IDIzLjA5IDE3MS4yOSAyMy4xMSAxNjkuNTMgMTguOTIgMTYwLjY1IDE4Ljk0IDE2MC42NSAxNC4yNyAxNTUuOTYgMTQuMjcgMTU1Ljk2IDE4Ljk1IDE1MC4xNCAxOC45NyAxNTEuODQgMTUuNDggMTUxLjcyIDE1LjIxIDE0Ny4xNiAxNS4yMSAxNDIuMTUgMjQuOTcgMTQyLjI2IDI1LjIxIDE0Ny4xMiAyNS4xNSAxNDguMTQgMjMuMDUgMTU1Ljk2IDIzLjA3IDE1NS45NiAyNy40MSAxNDEuNDEgMjcuNDEgMTQxLjQxIDMxLjg4IDE3NC45NyAzMS44OCAxNzMuMDkgMjcuNDEiLz48cG9seWdvbiBjbGFzcz0iY2xzLTEiIHBvaW50cz0iMTA2LjI0IDE5LjgxIDEzMS41IDIwLjAxIDEzMS4yMyAyMy4zMiAxMzQuNjggMjMuMzYgMTM0LjcyIDE4LjU5IDEzNC43MyAxOC41OSAxMzQuNzMgMTYuNjcgMTIxLjQ5IDE2LjY3IDEyMi40NSAxMy40OCAxMjAuMzggMTMuNDggMTE2LjcyIDEzLjQ4IDExNC42NCAxMy40OCAxMTUuNjEgMTYuNjcgMTAyLjM3IDE2LjY3IDEwMi4zMSAyMyAxMDUuOCAyMy4wNCAxMDYuMjQgMTkuODEiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0xMjkuMzEsMjQuNWwuMjktMi44OC0yMS41My0uMTktLjQsMi44OS02LjQzLS4wNSwwLDMuMjMsNiwuMDUtLjQsMywyMS44Ni4xOS4zMy0zLDYuODkuMDYsMC0zLjIzWm0tMTMuMTYsMy44NS01LS4wNS4xNy0xLjIxLDUsMFptLjQxLTMuNDYtNSwwLC4xNi0xLjEsNSwwWm04LjE5LDMuNTMtNC45MSwwLC4xNi0xLjIyLDQuODcsMFptLjMzLTMuNDYtNC43OSwwLC4wOC0xLjEsNC44LDBaIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMTI2LjMsNDQuNTVsNC41MSwwLC4xMS0xMi4zMi0yNC44LS4yMUwxMDYsNDQuMzhsMy44NSwwLTUuNzgsMi43NCwwLC4xOCwzLDIuMzIsOC4xMS0zLjg1LjA2LS4yMS0xLjUyLTEuMTUsOC42MS4wOC0xLjY3LDEuMjcsMCwuMiw4LjMsMy43NSwzLjc1LTIuMzUsMC0uMThabS0uMDctMi4yNC0xNS44Mi0uMTRWNDFsMTUuODIuMTNabTAtMy4zNS0xNS44Mi0uMTNWMzcuNjVsMTUuODIuMTNabTAtMy4zNS0xNS44Mi0uMTN2LTEuMWwxNS44Mi4xM1oiLz48cGF0aCBjbGFzcz0iY2xzLTIiIGQ9Ik0yMjEuOCwxMDAuNjFIMjc3YTMsMywwLDAsMCwzLTNWMTYuNDVhMywzLDAsMCwwLTMtM2gtNTUuOWw0My42OSw0Mi43NGEyLjkxLDIuOTEsMCwwLDEsLjA1LDQuMUwyMjYuMjIsOTkuNzRhMi45MSwyLjkxLDAsMCwxLTIuMDcuODdtLTIuMzUsMGgtMS4zMSIvPjxwYXRoIGNsYXNzPSJjbHMtMyIgZD0iTTIxMy43MiwxMDAuNTZoMGwwLDBoLjU0QTIuNDcsMi40NywwLDAsMSwyMTMuNzIsMTAwLjU2WiIvPjxwYXRoIGNsYXNzPSJjbHMtMyIgZD0iTTI2NC43NCw1Ni4yMiwyMDguMTEuODNhMi44OSwyLjg5LDAsMCwwLTQuMDksMEwyMDEuMiwzLjc0bDUzLjY1LDUyLjQ4YTIuOSwyLjksMCwwLDEsMCw0LjFMMjE2LjMzLDk5Ljc0YTIuOTEsMi45MSwwLDAsMS0yLjA3Ljg3aDkuODlhMi45MSwyLjkxLDAsMCwwLDIuMDctLjg3bDM4LjU3LTM5LjQyQTIuOTEsMi45MSwwLDAsMCwyNjQuNzQsNTYuMjJaIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMjU0Ljg1LDU2LjIyLDE5OC4yMi44M2EyLjksMi45LDAsMCwwLTQuMSwwTDE3OC45MSwxNi40MWEzLDMsMCwwLDAtLjU3LDMuMmwzMy4yNSw3OS4yM2EyLjg4LDIuODgsMCwwLDAsMi4xMywxLjcyLDIuNDcsMi40NywwLDAsMCwuNTQsMCwyLjkxLDIuOTEsMCwwLDAsMi4wNy0uODdsMzguNTYtMzkuNDJBMi45LDIuOSwwLDAsMCwyNTQuODUsNTYuMjJaIi8+PHBvbHlnb24gY2xhc3M9ImNscy0xIiBwb2ludHM9IjMyLjU4IDcyLjM3IDMyLjY1IDcyLjI5IDMyLjY1IDcxLjUyIDE0Ljg1IDU0LjcxIDM5LjEyIDU0LjcxIDM5LjEyIDQ0Ljc3IDAgNDQuNzcgMCA1My41OSAxNy44OCA3MS45NCAwIDkwLjgzIDAgOTkuNTggMzkuNTEgOTkuNTggMzkuNTEgODkuNjMgMTYuNTQgODkuNjMgMzIuNTggNzIuMzciLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik03MS4wNiw4OC44MWE4LjEzLDguMTMsMCwwLDEtMi44OSwyLjQ3LDkuMDYsOS4wNiwwLDAsMS00LjI1LDEsOS42LDkuNiwwLDAsMS0zLjg2LS43Niw5LjA1LDkuMDUsMCwwLDEtMy0yLjEyLDkuODQsOS44NCwwLDAsMS0yLTMuMjcsMTIsMTIsMCwwLDEtLjcyLTQuMjMsMTEuNjMsMTEuNjMsMCwwLDEsLjcyLTQuMTUsMTAsMTAsMCwwLDEsMi0zLjI3LDkuMTEsOS4xMSwwLDAsMSwzLjA3LTIuMTcsMTAuMSwxMC4xLDAsMCwxLDcuNzcsMCw2LjgxLDYuODEsMCwwLDEsMywyLjMxbC4xOS4yNyw2LjEyLTYuMTJMNzcsNjguNWExNC4yMSwxNC4yMSwwLDAsMC01Ljg5LTMuODksMjEuNzIsMjEuNzIsMCwwLDAtMTQuODYsMCwxOCwxOCwwLDAsMC02LjA5LDMuNzIsMTcuMjcsMTcuMjcsMCwwLDAtNC4wNyw1Ljg3LDIwLjcxLDIwLjcxLDAsMCwwLDAsMTUuMjUsMTgsMTgsMCwwLDAsNCw1LjkyLDE3Ljc2LDE3Ljc2LDAsMCwwLDYsMy44MSwyMC42MywyMC42MywwLDAsMCw3LjU1LDEuMzUsMTkuMDUsMTkuMDUsMCwwLDAsNy45My0xLjU3LDE3LDE3LDAsMCwwLDUuNzktNC4yOGwuMTgtLjItNi4yOC01LjkxWiIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTExOCw3NC4xYTE2LjgsMTYuOCwwLDAsMC00LTUuODIsMTcuNjksMTcuNjksMCwwLDAtNi4xMS0zLjY5LDIyLjIzLDIyLjIzLDAsMCwwLTcuNjYtMS4yOSwyMiwyMiwwLDAsMC03LjY0LDEuMjksMTcuNzgsMTcuNzgsMCwwLDAtNS40NCwzLjExbDYuNTQsNi4yM2E5LjM5LDkuMzksMCwwLDEsMi42MS0xLjcyLDkuNjQsOS42NCwwLDAsMSwzLjkzLS43OSw5Ljc1LDkuNzUsMCwwLDEsMy45My43OSw5LjE3LDkuMTcsMCwwLDEsMy4wNSwyLjE0LDkuNzQsOS43NCwwLDAsMSwyLDMuMjgsMTEuODEsMTEuODEsMCwwLDEsLjcxLDQuMTIsMTIuMzQsMTIuMzQsMCwwLDEtLjcxLDQuMjUsOS43MSw5LjcxLDAsMCwxLTIsMy4zMiw5LjIzLDkuMjMsMCwwLDEtMywyLjE3LDEwLjEyLDEwLjEyLDAsMCwxLTcuODQsMCw4LjkxLDguOTEsMCwwLDEtMi45LTJsLTYuMTEsNi42MWExOC4zLDE4LjMsMCwwLDAsNS4yOCwzLjExLDIyLjU2LDIyLjU2LDAsMCwwLDE1LjMyLDBBMTgsMTgsMCwwLDAsMTE0LDk1LjM1YTE3LjQzLDE3LjQzLDAsMCwwLDQtNS45NSwyMC45MSwyMC45MSwwLDAsMCwwLTE1LjNaIi8+PHBhdGggY2xhc3M9ImNscy0zIiBkPSJNOTMuMjYsODkuMzJsLjExLjEzLTYuMTEsNi42MWMtLjI4LS4yMy0uNTQtLjQ2LS43OS0uNzFhMTcuNDYsMTcuNDYsMCwwLDEtNC01Ljk1LDIxLDIxLDAsMCwxLDAtMTUuMywxNi44MywxNi44MywwLDAsMSw0LTUuODJjLjIxLS4yLjQyLS4zOS42NS0uNThsNi41NCw2LjIzLS40NC40M2E5LjQxLDkuNDEsMCwwLDAtMiwzLjI3LDExLjc2LDExLjc2LDAsMCwwLS42OSw0LjEyQTEyLjExLDEyLjExLDAsMCwwLDkxLjI3LDg2LDkuNjcsOS42NywwLDAsMCw5My4yNiw4OS4zMloiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0xNDguMjgsODUuNDlhMTAuMTksMTAuMTksMCwwLDEtLjMzLDIuNjMsNi4xMSw2LjExLDAsMCwxLTEuMDgsMi4xOCw1LjI5LDUuMjksMCwwLDEtMS45NCwxLjUyLDcuNzksNy43OSwwLDAsMS01LjgsMCw1LjA4LDUuMDgsMCwwLDEtMS45MS0xLjUyLDYuNSw2LjUsMCwwLDEtMS4wOC0yLjE5LDkuMzIsOS4zMiwwLDAsMS0uMzYtMi42MlY2NC4yM2gtOC45MnYyMkExNS41NCwxNS41NCwwLDAsMCwxMjcuOTIsOTJhMTIuOCwxMi44LDAsMCwwLDMsNC41MywxNCwxNCwwLDAsMCw0Ljc2LDIuOTMsMTkuMzEsMTkuMzEsMCwwLDAsMTIuNTYsMCwxNC4yMSwxNC4yMSwwLDAsMCw0LjgzLTIuOTNBMTIuNjksMTIuNjksMCwwLDAsMTU2LjE3LDkyYTE1LjI1LDE1LjI1LDAsMCwwLDEuMDgtNS44M3YtMjJoLTlaIi8+PHBvbHlnb24gY2xhc3M9ImNscy0xIiBwb2ludHM9IjE4OC40MyA2NC4yMiAxNjIuMzcgNjQuMjIgMTYyLjM3IDcxLjk2IDE3Mi4xOSA3MS45NiAxNzIuMTkgOTkuNTggMTgxLjE2IDk5LjU4IDE4MS4xNiA3MS45NiAxOTEuNjggNzEuOTYgMTg4LjQzIDY0LjIyIi8+PGxpbmUgY2xhc3M9ImNscy00IiB4MT0iOTMuNjgiIHkxPSI3My45NCIgeDI9IjkzLjY2IiB5Mj0iNzMuOTMiLz48L2c+PC9nPjwvc3ZnPg=='
const logoSvg = `<title>black</title>
    <g id="black" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M98.978,44 C108.764,44 110.696,38.792 110.696,34.97 C110.696,30.812 107.798,28.922 104.984,28.586 L104.984,28.418 C107.21,27.62 109.268,25.52 109.268,22.202 C109.268,16.28 104.984,14.558 99.776,14.558 L89.234,14.558 L89.234,44 L98.978,44 Z M98.768,26.36 L95.576,26.36 L95.576,19.85 L99.02,19.85 C102.044,19.85 103.094,21.278 103.094,23.084 C103.094,24.764 101.876,26.36 98.768,26.36 Z M99.986,38.708 L95.576,38.708 L95.576,31.652 L99.65,31.652 C102.044,31.652 104.186,32.618 104.186,35.18 C104.186,36.86 103.22,38.708 99.986,38.708 Z M123.254,44.462 C126.236,44.462 128.126,43.496 129.512,41.816 L129.68,41.816 L130.562,44 L135.938,44 L135.938,20.27 L129.596,20.27 L129.596,36.692 C129.26,37.448 128.252,39.548 125.48,39.548 C123.338,39.548 122.078,38.204 122.078,35.6 L122.078,20.27 L115.736,20.27 L115.736,36.188 C115.736,41.816 118.172,44.462 123.254,44.462 Z M148.832,44.42 C155.72,44.42 158.198,40.178 158.198,37.028 C158.198,29.09 147.026,30.35 147.026,26.78 C147.026,25.688 147.95,24.932 149.378,24.932 C151.562,24.932 153.2,26.192 154.04,27.158 L158.114,23.168 C156.56,21.362 153.83,19.85 149.546,19.85 C144.044,19.85 140.726,23.336 140.726,27.2 C140.726,35.096 151.898,33.962 151.898,37.406 C151.898,38.498 151.142,39.422 149.168,39.422 C146.312,39.422 144.002,37.7 142.952,36.482 L139.172,40.85 C140.474,42.236 143.624,44.42 148.832,44.42 Z M165.716,17.666 C167.858,17.666 169.454,16.07 169.454,14.096 C169.454,11.912 167.858,10.316 165.716,10.316 C163.7,10.316 162.104,11.912 162.104,14.096 C162.104,16.07 163.7,17.666 165.716,17.666 Z M168.992,44 L168.992,20.27 L162.65,20.27 L162.65,44 L168.992,44 Z M181.214,44 L181.214,27.872 C181.928,26.15 183.44,25.058 185.288,25.058 C187.43,25.058 188.564,26.486 188.564,28.922 L188.564,44 L194.906,44 L194.906,27.578 C194.906,22.244 192.26,19.682 187.64,19.682 C185.162,19.682 182.684,20.774 181.256,22.496 L181.088,22.496 L179.828,20.27 L174.872,20.27 L174.872,44 L181.214,44 Z M210.572,44.462 C215.108,44.462 217.418,43.328 219.266,41.816 L216.494,37.322 C215.612,38.246 213.848,39.464 211.286,39.464 C207.254,39.464 205.574,37.406 205.49,33.668 L219.644,33.668 C219.896,31.82 219.938,30.644 219.938,29.426 C219.938,23.63 216.452,19.808 210.404,19.808 C203.558,19.808 199.274,24.386 199.274,32.072 C199.274,40.262 203.096,44.462 210.572,44.462 Z M213.974,29.468 L205.616,29.468 C205.7,26.696 207.38,24.596 210.236,24.596 C212.798,24.596 213.974,26.066 213.974,28.838 L213.974,29.468 Z M231.698,44.42 C238.586,44.42 241.064,40.178 241.064,37.028 C241.064,29.09 229.892,30.35 229.892,26.78 C229.892,25.688 230.816,24.932 232.244,24.932 C234.428,24.932 236.066,26.192 236.906,27.158 L240.98,23.168 C239.426,21.362 236.696,19.85 232.412,19.85 C226.91,19.85 223.592,23.336 223.592,27.2 C223.592,35.096 234.764,33.962 234.764,37.406 C234.764,38.498 234.008,39.422 232.034,39.422 C229.178,39.422 226.868,37.7 225.818,36.482 L222.038,40.85 C223.34,42.236 226.49,44.42 231.698,44.42 Z M252.53,44.42 C259.418,44.42 261.896,40.178 261.896,37.028 C261.896,29.09 250.724,30.35 250.724,26.78 C250.724,25.688 251.648,24.932 253.076,24.932 C255.26,24.932 256.898,26.192 257.738,27.158 L261.812,23.168 C260.258,21.362 257.528,19.85 253.244,19.85 C247.742,19.85 244.424,23.336 244.424,27.2 C244.424,35.096 255.596,33.962 255.596,37.406 C255.596,38.498 254.84,39.422 252.866,39.422 C250.01,39.422 247.7,37.7 246.65,36.482 L242.87,40.85 C244.172,42.236 247.322,44.42 252.53,44.42 Z M290.372,44.42 C295.832,44.42 298.772,43.286 300.914,41.816 L300.914,28.838 L294.488,28.838 L294.488,38.792 C293.9,39.044 292.598,39.212 291.716,39.212 C286.802,39.212 284.45,36.062 284.45,28.796 C284.45,21.824 287.726,19.682 291.59,19.682 C294.32,19.682 295.874,20.858 296.966,22.034 L301.082,17.54 C300.284,16.616 297.638,14.138 291.842,14.138 C284.03,14.138 277.856,18.926 277.856,29.552 C277.856,39.38 282.014,44.42 290.372,44.42 Z M316.454,44.462 C320.99,44.462 323.3,43.328 325.148,41.816 L322.376,37.322 C321.494,38.246 319.73,39.464 317.168,39.464 C313.136,39.464 311.456,37.406 311.372,33.668 L325.526,33.668 C325.778,31.82 325.82,30.644 325.82,29.426 C325.82,23.63 322.334,19.808 316.286,19.808 C309.44,19.808 305.156,24.386 305.156,32.072 C305.156,40.262 308.978,44.462 316.454,44.462 Z M319.856,29.468 L311.498,29.468 C311.582,26.696 313.262,24.596 316.118,24.596 C318.68,24.596 319.856,26.066 319.856,28.838 L319.856,29.468 Z M336.74,44 L336.74,27.872 C337.454,26.15 338.966,25.058 340.814,25.058 C342.956,25.058 344.09,26.486 344.09,28.922 L344.09,44 L350.432,44 L350.432,27.578 C350.432,22.244 347.786,19.682 343.166,19.682 C340.688,19.682 338.21,20.774 336.782,22.496 L336.614,22.496 L335.354,20.27 L330.398,20.27 L330.398,44 L336.74,44 Z M359.294,17.666 C361.436,17.666 363.032,16.07 363.032,14.096 C363.032,11.912 361.436,10.316 359.294,10.316 C357.278,10.316 355.682,11.912 355.682,14.096 C355.682,16.07 357.278,17.666 359.294,17.666 Z M362.57,44 L362.57,20.27 L356.228,20.27 L356.228,44 L362.57,44 Z M378.488,44.462 C383.024,44.462 385.334,43.328 387.182,41.816 L384.41,37.322 C383.528,38.246 381.764,39.464 379.202,39.464 C375.17,39.464 373.49,37.406 373.406,33.668 L387.56,33.668 C387.812,31.82 387.854,30.644 387.854,29.426 C387.854,23.63 384.368,19.808 378.32,19.808 C371.474,19.808 367.19,24.386 367.19,32.072 C367.19,40.262 371.012,44.462 378.488,44.462 Z M381.89,29.468 L373.532,29.468 C373.616,26.696 375.296,24.596 378.152,24.596 C380.714,24.596 381.89,26.066 381.89,28.838 L381.89,29.468 Z" id="BusinessGenie" fill="#222222" fill-rule="nonzero"/>
        <g id="Group" transform="translate(26.000000, 0.000000)" fill="#222222" fill-rule="nonzero">
            <path d="M19,29 L32,29 C32,29 31.3645621,25.0334768 25.1849287,25.0334768 C19.0052953,25.0334768 19,29 19,29 L19,29 Z M25.4814664,18 L23.3633401,20.3830703 C24.0892986,21.0232202 24.6937199,21.7876084 25.1478615,22.6398852 C23.8293279,22.8660928 23.8293279,24.4179818 23.8293279,24.4179818 C24.9535357,24.198464 26.1100081,24.198464 27.2342159,24.4179818 C27.2342159,24.4179818 27.1494908,22.8766141 25.8309572,22.6398852 C26.3429915,21.820943 26.950895,21.0651566 27.6419552,20.3883309 L25.5238289,18.0052606 L25.4814664,18 Z" id="Shape"/>
            <path d="M48.8690451,21.689923 C46.098997,16.4484365 39.5872366,17.8640204 37.5955935,19.4490372 C35.9851004,20.7498441 34.3746073,23.7559104 35.6307919,26.0569175 C36.8869765,28.3579246 39.8449155,29.4291773 41.6432994,29.008328 C43.7423088,28.494564 46.0506822,26.2755405 44.9501786,24.0073268 C43.5490496,21.1269687 40.0381747,22.3676543 39.7697592,24.0073268 C39.6493082,24.4305347 39.7437589,24.8870223 40.0216623,25.224794 C40.2995657,25.5625656 40.7244278,25.7372654 41.1547832,25.6907239 C41.4780953,25.6410072 41.7684274,25.4616495 41.9610469,25.1926408 C42.1536663,24.9236321 42.2325574,24.5873395 42.1801305,24.2587433 C42.1801305,24.0838449 42.223077,24.0893104 42.3733896,23.9909301 C42.9961136,23.5810119 44.6066067,25.5376878 42.1425523,26.9423406 C39.3832408,28.5164263 35.5878454,24.7561106 38.8034633,21.6243361 C42.4914925,18.0006598 47.9295908,21.8047 47.6450703,25.6852584 C47.3605499,29.5658167 44.4938722,31.0415219 42.1801305,31.2437482 C40.8132229,31.3327107 39.453753,31.5153098 38.1109513,31.7903057 C36.1568863,30.2380824 32.8500072,29.008328 32.8500072,29.008328 L18.6239849,29.008328 C16.600132,29.5002298 13.9803966,31.5443549 11.478764,29.9812004 C9.81995608,28.9427411 7.6350538,27.5927441 6.35202764,26.8057013 C5.76826241,26.4344606 5.07227917,26.2908006 4.39259438,26.4012487 C3.25086391,26.5591976 2.0899618,26.4924006 0.972980732,26.204488 C0.836664874,26.1695339 0.692178085,26.1953766 0.575725771,26.2755405 L0.221417292,26.5214913 C0.05431098,26.634039 -0.0294501077,26.8382219 0.00939118092,27.0383437 C0.0482324695,27.2384656 0.201978483,27.3948656 0.398571532,27.4342424 C2.95388723,27.9807999 5.76688182,29.9757348 5.76688182,29.9757348 C12.794,33.741516 16.600132,42 25.5759468,42 C34.439027,42 38.175371,37.0317922 39.351031,34.4902998 C41.6540361,33.9437423 43.6456792,34.0585194 46.098997,32.5664174 C48.7777838,30.9048826 51.6390932,26.9314095 48.8690451,21.689923 L48.8690451,21.689923 Z" id="Path"/>
            <path d="M3.5382908,26.7207875 C4.15807222,26.0979289 5.14117379,20.0465354 8.96137823,19.3162874 C12.7815827,18.5860394 18.2580995,21.5392483 23.1255209,15.7348504 C27.9929422,9.93045257 21.8432145,6 21.8432145,6 C21.8432145,6 25.8023355,9.65660956 22.9118031,14.1454871 C21.7623301,15.8862621 20.0073999,17.1328764 17.9909524,17.6410125 C16.0272685,18.134909 13.9908707,18.2677046 11.9801412,18.0329839 C8.80643288,17.7000767 6.74405677,18.4410637 5.33351975,20.2774227 C6.49828138,18.3497827 8.12253614,17.0557402 10.4680882,17.1631296 C15.2233078,17.4316032 17.3123986,17.0718486 17.3123986,17.0718486 C24.7925192,14.9240603 23.1255209,8.85118895 23.1255209,8.85118895 C22.9812614,14.0219893 20.5128216,15.3750959 17.4940587,15.7348504 C14.4752957,16.094605 9.62924614,14.7092815 6.5623967,17.5228842 C2.97193882,20.8143697 3.00399647,26.7207875 3.00399647,26.7207875 C3.00399647,26.7207875 2.91850938,27.3490156 3.5382908,26.7207875 L3.5382908,26.7207875 Z" id="Path"/>
            <path d="M15.0911356,6.57936326 C19.4432182,8.70345148 21.6486294,8.38483824 21.3015308,11.9692371 C21.3015308,11.9692371 22.9035244,8.17242942 19.9772161,7.15286708 C17.0509078,6.13330473 14.9149163,4.08886982 19,3.61094997 C23.0850837,3.13303012 22.5297259,1.01425212 21.744749,0.0424817644 C21.744749,0.0424817644 22.5564258,1.72051146 20.511214,2.07629623 C18.4660021,2.43208101 17.5795657,1.63554793 15.0911356,2.34180726 C15.0911356,2.33649704 10.739053,4.45527504 15.0911356,6.57936326 Z M6.37095052,11.2948391 L6.94766821,9.02206471 L8.58170167,8.59193684 L6.89426842,8.26270317 L6.37095052,6.10144341 L5.78889284,8.26270317 L4,8.59193684 L5.73549306,9.04330559 L6.37095052,11.2948391 L6.37095052,11.2948391 Z M32.4727661,15.3571578 L32.8732645,13.7853325 L34,13.4932704 L32.8358847,13.2649309 L32.4727661,11.772759 L32.0722677,13.2649309 L30.8333927,13.4932704 L32.0348879,13.8065734 L32.4727661,15.3571578 Z M26.1075116,3.58439887 L26.50801,2.01788381 L27.6347455,1.72051146 L26.4706301,1.49217197 L26.1075116,0 L25.7070132,1.49217197 L24.4681381,1.72051146 L25.6696333,2.03381447 L26.1075116,3.58439887 Z M30.0590958,47.1122767 C29.1601804,46.9286236 28.2506166,46.8009301 27.3357067,46.7299408 C27.1103417,46.2985046 27.0496426,45.8005275 27.1648273,45.3280426 C28.0158677,45.1870297 28.7480224,44.6503459 29.1352795,43.8836626 L29.493058,42.8216185 C24.991456,43.7615275 22.5510858,42.8216185 22.5510858,42.8216185 L22.9088644,43.942075 C22.9088644,43.942075 23.1278035,45.0784622 24.8953364,45.3917652 C25.0053568,45.840916 24.9543675,46.3141635 24.751157,46.7299408 C23.8446389,46.8107843 22.944021,46.947341 22.0544678,47.1388278 C20.8297036,47.4730515 19.7792912,48.2593193 19.1174795,49.3372591 C18.9696323,49.557134 18.9420478,49.8359322 19.0439681,50.0802446 C19.1458884,50.3245569 19.3638316,50.5020663 19.6247775,50.5532996 C21.6747621,50.8619525 23.7458378,51.0110912 25.8191527,50.9993581 L26.2997508,50.9993581 C28.3730657,51.0110912 30.4441415,50.8619525 32.494126,50.5532996 C32.7550719,50.5020663 32.9730152,50.3245569 33.0749354,50.0802446 C33.1768557,49.8359322 33.1492712,49.557134 33.001424,49.3372591 C32.3434237,48.2482175 31.2902455,47.4518064 30.0590958,47.1122767 L30.0590958,47.1122767 Z" id="Shape"/>
        </g>
    </g>
</svg>`

const directionMap = {
  RL: {
    value: 'RL',
    tooltip: '由右至左顯示',
    icon: [ 'fas', 'long-arrow-alt-left' ]
  },
  LR: {
    value: 'LR',
    tooltip: '由左至右顯示',
    icon: [ 'fas', 'long-arrow-alt-right' ]
  },
  TB: {
    value: 'TB',
    tooltip: '由上至下顯示',
    icon: [ 'fas', 'long-arrow-alt-down' ]
  }
}

// 切換方向按鈕的倒數計時器
let mouseoutCounter = -1
let isCountdownOn = false

function hasNode (nodes, itemUniID, itemName?): boolean {
  return nodes.some(d => {
    return d.id === itemUniID || (itemName != null && d.id === itemName)
  })
}

function hasEdge (edges, _start, _end): boolean {
  return edges.some(d => d._start === _start && d._end === _end)
}

function isCompanyClosed (company_state) {
  if (company_state !== '核准設立') {
    if (company_state === '歇業'
    || company_state === '廢止'
    || company_state === '廢止已清算完結'
    || company_state === '廢止許可'
    || company_state === '廢止許可已清算完結'
    || company_state === '廢止認許'
    || company_state === '廢止認許已清算完結'
    || company_state === '廢止登記'
    || company_state === '撤回認許'
    || company_state === '撤回認許已清算完結'
    || company_state === '撤回登記'
    || company_state === '撤回登記已清算完結'
    || company_state === '撤銷'
    || company_state === '撤銷登記'
    || company_state === '撤銷已清算完結'
    || company_state === '撤銷無須清算'
    || company_state === '撤銷許可'
    || company_state === '撤銷認許'
    || company_state === '撤銷認許已清算完結'
    || company_state === '撤銷公司設立'
    || company_state === '解散'
    || company_state === '解散已清算完結'
    || company_state === '合併解散'
    || company_state === '核准設立，但已命令解散') {
      return true
    }
  }
  return false
}

function returnTooltipText (shareholders: Array<ChartCardTypes.RenderShareholders>): string {
  return shareholders
    .map(d => {
      let bracketText = ''
      if (d.ROL) {
        bracketText += d.ROL
      }
      if (d.title) {
        if (bracketText) {
          bracketText += '，'
        }
        bracketText += d.title
      }
      if (d.stocks) {
        if (bracketText) {
          bracketText += '，'
        }
        bracketText += `持股 ${utils.formatCommaNumber(d.stocks)}`
      }
      return `${d.name}（${bracketText}）`
    })
    .join('</br>')
}

// 持有股份數百分比
function returnPercentageText (n) {
  if (n == null || n <= 0) {
    return '0.00%'
  }
  let newN = Math.round(n * 100) / 100
  return `${newN.toFixed(2)}%`
}

export default {
  props: {
    demoMode: {
      required: false,
      default () {
        return false
      }
    },
    'uniID': {
      required: true
    },
    'companyName': {
      required: true
    },
    options: {
      default () {
        return {
          stockMin: 0,
          expandAllNodes: false, // 展開所有節點
          mergeName: false, // 合併相同姓名
          direction: 'RL'
        }
      }
    },
    // 圖表所需的所有節點資料（api的原始結構未parse）
    companyDataList: {
      required: true
    },
    size: {
      required: false,
      default () {
        return {
          position: 'relative',
          // width: '1200px',
          width: 'calc( 100% - 84px)',
          height: '800px'
        }
      }
    }
  },
  components: {
    DagreDirectedChart,
    CompanySummaryLightbox
  },
  data () {
    return {
      chartData: {
        nodes: [],
        edges: [],
        expandAll: false,
        direction: 'RL'
      },
      chartOptions: {
        name: `dagre-directed-chart__${Math.random().toString(36).substr(2, 5)}`,
        title: `【${this.companyName}】股權結構分析圖`,
        subtitle: '「股權百分比」預設為每股面額 10 元，算法：持有股份/(實收資本額/10)*100%。如出現持股逾 100% 的情形，係因該單位每股面額非 10 元之故。',
        watermarkBase64: '',
        // logoBase64: logoSvgBase64,
        footerHtml: logoSvg,
        tooltip: `股權結構分析圖係依您所查詢之公司，並根據經濟部 OPEN DATA 進行股權計算之樹狀結構圖。<br>
                  ．箭頭所流向之單位，表示為公司所投資之對象或擔任其董事、監察人。<br>
                  ．箭頭所源於之單位或自然人，表示為公司之董監事或監察人。`,
        size: 'auto',
        style: cardStyle
      },
      isFullScreen: false,
      screenShotMode: false,
      // companyStockRelationship: null,
      // nodes: [],
      // edges: [],
      loadedNodeUniIDs: [], // 紀錄已載入進來的所有node id
      // nodeClassNames: {
      //   root: 'rectRoot',
      //   company: 'rectCompany',
      //   person: 'rectPerson'
      // },
      isShowChart: true,
      isShowDirectionMenu: false,
      isCompanyLightboxVisible: false,
      companyLightboxBasic: {},
      // 方向
      direction: 'RL',
      styleConfig: {
        styles: {
        // 一般文字
          text: 'fill: #303133;font-weight: normal;font-size: 14px;',
          // 根節點文字
          textRoot: 'fill: #c00;font-weight: bold;font-size: 14px;',
          // 上游的線
          pathTop: 'stroke: #909399; stroke-width: 1.5px; fill:none;',
          // 下游的線
          pathDown: 'stroke: #eb9999; stroke-width: 1.5px; fill:none;',
          // 歇業公司的線
          pathClosed: 'stroke: #c0c4cc; stroke-width: 1.5px; fill:none;',
          // 上游的指標
          arrowTop: 'fill: #909399',
          // 下游的指標
          arrowDown: 'fill: #eb9999',
          // 歇業公司的指標
          arrowClosed: 'fill: #c0c4cc',
          // 根節點
          rectRoot: 'rx:5px;ry:5px;stroke:#eb9999;stroke-width:3px;fill:#fae6e6;',
          // 公司節點
          rectCompany: 'rx:5px;ry:5px;stroke: #909399;stroke-width: 1.5px;fill: #fff;',
          // 自然人節點
          rectPerson: 'rx:19px;ry:19px;stroke: #909399;stroke-width: 1.5px;fill: #fff;',
          // 下游公司節點
          rectCompanyDown: 'rx:5px;ry:5px;stroke: #eb9999;stroke-width: 1.5px;fill: #fff;',
          // 已歇業公司根節點
          rectRootClosed: 'rx:5px;ry:5px;stroke:#c0c4cc;stroke-width:3px;fill:#DCDFE6;',
          // 已歇業公司節點
          rectCompanyClosed: 'rx:5px;ry:5px;stroke: #c0c4cc;stroke-width: 1.5px;fill: #DCDFE6;',
          // 展開按鈕
          expandBtn: 'fill:#000000'
        }
      }
    }
  },
  computed: {
    syncOptions: {
      get () {
        return this.options
      },
      set (d) {
        this.$emit('update:options', d)
      }
    },
    containerSize () {
      if (this.isFullScreen) {
        return {
          position: 'fixed',
          width: '100vw',
          height: '100vh',
          top: '0px',
          left: '0px',
          'z-index': 2000
        }
      // } else if (this.isFullScreen && this.screenShotMode === true) {
      //   return {
      //     position: 'fixed',
      //     width: '100%',
      //     height: '100%',
      //     top: '0px',
      //     left: '0px',
      //     'z-index': 10000
      //   }
      } else {
        return this.size
      }
    },
    chartPosition () {
      if (this.screenShotMode) {
        return {
          position: 'fixed',
          top: '0px',
          left: '0px',
          'z-index': 10001
        }
      } else {
        return {
          position: 'relative'
        }
      }
    },
    fullScreenIcon () {
      if (this.isFullScreen) {
        return 'compress'
      } else {
        return 'expand'
      }
    },
    rootID () {
      return this.uniID
      // return '80333183'
      // this.basic.uniID
    },
    // directionTooltip () {
    //   if (this.syncOptions.direction === 'RL') {
    //     return '由右至左顯示'
    //   } else if (this.syncOptions.direction === 'LR') {
    //     return '由左至右顯示'
    //   } else if (this.syncOptions.direction === 'TB') {
    //     return '由上至下顯示'
    //   }
    //   return ''
    // },
    // directionIcon () {
    //   if (this.syncOptions.direction === 'RL') {
    //     return [ 'fas', 'long-arrow-alt-left' ]
    //   } else if (this.syncOptions.direction === 'LR') {
    //     return [ 'fas', 'long-arrow-alt-right' ]
    //   } else if (this.syncOptions.direction === 'TB') {
    //     return [ 'fas', 'long-arrow-alt-down' ]
    //   }
    //   return ''
    // },
    directionMenu () {
      if (this.syncOptions.direction === 'RL') {
        // return [directionMap.RL, directionMap.LR, directionMap.TB]
        return [directionMap.LR, directionMap.TB, directionMap.RL]
      } else if (this.syncOptions.direction === 'LR') {
        // return [directionMap.LR, directionMap.TB, directionMap.RL]
        return [directionMap.TB, directionMap.RL, directionMap.LR]
      } else if (this.syncOptions.direction === 'TB') {
        // return [directionMap.TB, directionMap.RL, directionMap.LR]
        return [directionMap.RL, directionMap.LR, directionMap.TB]
      }
      return []
    }
  },
  watch: {
    companyDataList: {
      handler (d) {
        if (d) {
          this.setChartData(JSON.parse(JSON.stringify(d)))
        }
      }
    }
  },
  mounted () {
    if (this.companyDataList.length) {
      this.setChartData(JSON.parse(JSON.stringify(this.companyDataList)))
    }
  },
  methods: {
    setChartData (companyDataList) {
      if (!companyDataList.length) {
        return
      }
      // companyDataList = companyDataList.map((d,i) => {
      //   if (i === 12) {
      //     debugger
      //   }
      //   if (d.basic.uniID.includes("28675461")) {
      //     debugger
      //   }
      //   d.basic.uniID = d.basic.uniID.substr(0,8)
      //   if (d.top && Object.keys(d.top).length) {
      //     Object.keys(d.top).forEach(name => {
      //       d.top[name].uniID = d.top[name].uniID.substr(0,8)
      //     })
      //   }
      //   if (d.down && Object.keys(d.down).length) {
      //     Object.keys(d.down).forEach(name => {
      //       d.down[name].uniID = d.down[name].uniID.substr(0,8)
      //     })
      //   }
      //   return d
      // })

      // 已載入的uniID
      this.loadedNodeUniIDs = companyDataList.map(d => d.basic.uniID)

      // -- 將api parse為圖表使用的資料格式 --
      let chartData = {
        nodes: [],
        edges: [],
        expandAll: this.syncOptions.expandAllNodes,
        direction: this.syncOptions.direction
      }
      for (const i in companyDataList) {
        const companyData = companyDataList[i]
        let data = {
          origin: {
            uniID: companyData.basic.uniID,
            company_name: companyData.basic.company_name,
            company_state: companyData.basic.company_state,
            shareholders: companyData.basic.shareholders
          },
          top: Object.assign(companyData.stock.top, companyData.stock['top-big']),
          topPerson: companyData.stock['top-person'],
          // down: companyData.stock.down
          down: null
        }
        // 只有根節點加上下流節點
        if (i == '0') {
          data.down = Object.assign(companyData.stock.down, companyData.stock['down-big'])
        }
        const { allNodes, allEdges } = this.parseNodesData(
          data,
          chartData.nodes,
          chartData.edges
        )
        chartData.nodes = allNodes
        chartData.edges = allEdges
      }

      // 過濾持股下限設定
      const newData = this.filterStockMin(chartData.nodes, chartData.edges, Number(this.syncOptions.stockMin))
      chartData.nodes = newData.nodes
      chartData.edges = newData.edges
      // 修正是否有展開按鈕
      this.modifyHasTopBtnStatus(chartData.nodes, chartData.edges, this.syncOptions.expandAllNodes)
      // 修正連接線方向狀態
      this.modifyDirectionStatus(chartData.nodes, chartData.edges)
      // 放入節點資料
      this.chartData = chartData
      console.log(JSON.parse(JSON.stringify(this.chartData)))
    },
    // changeDirection () {
    //   // this.syncOptions.direction = direction
    //   if (this.syncOptions.direction === 'RL') {
    //     this.$set(this.syncOptions, 'direction', 'LR')
    //   } else if (this.syncOptions.direction === 'LR') {
    //     this.$set(this.syncOptions, 'direction', 'TB')
    //   } else if (this.syncOptions.direction === 'TB') {
    //     this.$set(this.syncOptions, 'direction', 'RL')
    //   }
    // },
    handleDirectionMenuMouseout () {
      if (isCountdownOn) {
        return
      }
      isCountdownOn = true
      const countdown = () => {
        setTimeout(() => {
          mouseoutCounter -= 100
          if (mouseoutCounter > 0) {
            countdown()
            return
          }
          mouseoutCounter = -1
          isCountdownOn = false
          this.isShowDirectionMenu = false
        }, 100)
      }
      countdown()
    },
    async toggleDirectionMenu (isShow) {
      await this.$nextTick()
      this.isShowDirectionMenu = isShow
      if (isShow) {
        mouseoutCounter = 2000
      }
    },
    changeDirection (direction) {
      this.toggleDirectionMenu(false)

      this.$set(this.syncOptions, 'direction', direction)
      
    },
    async resetChart (value) {
      // 更新圖表
      this.isShowChart = false
      this.chartData = {
        nodes: [],
        links: [],
        expandAll: false
      }
      // 重新建立節點資料
      this.setChartData(JSON.parse(JSON.stringify(this.companyDataList)))
      await this.$nextTick()
      this.isShowChart = true
      // await this.$nextTick()
      
    },
    async toggleExpandedMode () {
      this.isShowChart = false
      this.$set(this.syncOptions, 'expandAllNodes', !this.syncOptions.expandAllNodes)
      let chartData = JSON.parse(JSON.stringify(this.chartData))
      // if (this.allNodesMode) {
      //   this.setAllExpanded(chartData.nodes, chartData.edges)
      // } else {
      //   this.setAllUnexpaned(chartData.nodes, chartData.edges)
      // }
      // 修正是否有展開按鈕
      this.modifyHasTopBtnStatus(chartData.nodes, chartData.edges, this.syncOptions.expandAllNodes)

      chartData.expandAll = this.syncOptions.expandAllNodes
      this.chartData = chartData
      await this.$nextTick()
      this.isShowChart = true
    },
    // 截圖
    async screenShot () {
      this.screenShotMode = true
      await new Promise(resolve => setTimeout(resolve, 500))
      let result = await screenImageGetter.downloadScreenImage(`#${this.chartOptions.name}`, this.chartOptions.title, '#app')
      this.screenShotMode = false
    },
    // 切換全營幕
    toggleFullScreen () {
      const chart = this.$refs.dagreDirectedChart.chart
      this.isFullScreen = !this.isFullScreen
      setTimeout(() => {
        chart.resize()
      })
    },
    // 點擊節點事件
    handleExtandBtnClick (d, toggleTopNodes) {
      // console.log(d)
      if (!d.uniID) {
        return
      }
      if (d.isTopExpanded === true) {
        // 目前是展開的則將狀態切換為關閉
        toggleTopNodes(d.id)
      } else if (this.loadedNodeUniIDs.indexOf(d.id) > 0) {
        // 如果曾經載入過資料則直接展開
        toggleTopNodes(d.id)
      } else {
        // @Q@ 預留的程式碼，目前的設計是開啟圖表前全部資料已取得，所以這段目前是用不到的，除非未來改成點擊節點時才取資料才會用到
        const searchQuery = {
          "uniID": d.uniID,
          "get": {
            "stock": {}
          }
        }
        apis.companyGet(searchQuery)
          .then((data) => {
            if (!data.payload || !this.stock) {
              console.error('ajax fail')
              return
            }
            this.loadedNodeUniIDs.push(data.payload.basic.uniID) // 紀錄已載入的node id
            let dataSet = {
              origin: {
                uniID: data.payload.basic.uniID,
                company_name: data.payload.basic.company_name,
                company_state: companyData.basic.company_state,
                shareholders: data.payload.basic.shareholders
              },
              top: data.payload.stock.top,
              topPerson: data.payload.stock['top-person']
            }
            // // 加入新增nodes
            // this.chart.addData(dataSet, false)
            // // 將狀態切換為展開
            // this.chart.toggleTopNodes(d.id)
            let chartData = JSON.parse(JSON.stringify(this.chartData))
            const { allNodes, allEdges } = this.parseNodesData(
              dataSet,
              chartData.nodes,
              chartData.edges
            )
            this.chartData = chartData
            setTimeout(() => {
              toggleTopNodes(data.payload.basic.uniID)
            })
          })
          .catch(e => {
            console.error(e)
          })
      }
    },
    handleNodeClick (d, toggleTopNodes) {
      if (this.demoMode) {
        return
      }
      const companyData = this.companyDataList.find(companyData => companyData.basic.uniID === d.id)
      if (!companyData) {
        return
      }
      this.companyLightboxBasic = companyData.basic
      this.isCompanyLightboxVisible = true
    },
    filterStockMin (allNodes: Array<ChartTypes.ChartNode>, allEdges: Array<ChartTypes.ChartEdge>, stockMin: number): {
    nodes: any[];
    edges: any[];} {
      let newData:any = {
        nodes: [],
        edges: []
      }
      // step1 過濾百分比
      newData.edges = allEdges.filter(edge => {
        return edge.percentage >= stockMin
      })
      // step2 過濾掉無連接到根節點的線
      const filterEdgesFromRoot = (edges) => {
        let newEdges = []
        const searchUp = (_start:string, _end:string) => {
          const upEdges = edges.filter(edge => _start === edge._end) // 上一層節點的連接線
          for (const edge of upEdges) {
            let isExist = newEdges.some(newEdge => {
              return newEdge._start === edge._start && newEdge._end === edge._end
            })
            if (isExist == false) {
              newEdges.push(edge)
              searchUp(edge._start, edge._end)
            }
          }
        }
        const topFromRoot = edges.filter(edge => edge._end === this.rootID)
        for (const edge of topFromRoot) {
          newEdges.push(edge)
          searchUp(edge._start, edge._end)
        }
        const searchDown = (_start:string, _end:string) => {
          const downEdges = edges.filter(edge => _end === edge._start) // 下一層節點的連接線
          for (const edge of downEdges) {
            let isExist = newEdges.some(newEdge => {
              return newEdge._start === edge._start && newEdge._end === edge._end
            })
            if (isExist == false) {
              newEdges.push(edge)
              searchDown(edge._start, edge._end)
            }
          }
        }
        const downFromRoot = edges.filter(edge => edge._start === this.rootID)
        for (const edge of downFromRoot) {
          let isExist = newEdges.some(newEdge => {
            return newEdge._start === edge._start && newEdge._end === edge._end
          })
          if (isExist == false) {
            newEdges.push(edge)
          }
          searchDown(edge._start, edge._end)
        }

        return newEdges
      }
      newData.edges = filterEdgesFromRoot(newData.edges)
      // step3 過濾掉無連接線的節點
      newData.nodes = allNodes.filter(node => {
        return newData.edges.find((edge:ChartTypes.ChartEdge) => node.id === edge._start || node.id === edge._end) != null
      })
      return newData
    },
    // -- 轉換資料 --
    addOriginData (
      originData: ChartCardTypes.RenderDataOrigin,
      nodes: Array<ChartTypes.ChartNode>
    ): void {
      // if (hasNode(nodes, originData.uniID, originData.company_name) === false) {
        nodes.push({
          id: originData.uniID,
          uniID: originData.uniID,
          label: originData.company_name,
          style: isCompanyClosed(originData.company_state) ? 'rectRootClosed' : 'rectRoot',
          tooltip: returnTooltipText(originData.shareholders),
          companyState: originData.company_state,
          hasTop: false, // 根節點不做展開資料的判斷
          isTopExpanded: false,
          // source: originData
        })
      // }
    },
    addTopData (
      originData: ChartCardTypes.RenderDataOrigin,
      topData: ChartCardTypes.RenderDataTop,
      nodes: Array<ChartTypes.ChartNode>,
      edges: Array<ChartTypes.ChartEdge>
    ): void {
      Object.keys(topData).forEach(d => {
        const _start = topData[d].uniID || d
        const _end = originData.uniID
        if (hasNode(nodes, topData[d].uniID, d) === false) {
          nodes.push({
            id: topData[d].uniID || d, // 如無uniID使用公司名稱
            uniID: topData[d].uniID || '',
            label: d,
            style: isCompanyClosed(topData[d].company_state) ? 'rectCompanyClosed' : 'rectCompany',
            tooltip: returnTooltipText(topData[d].shareholders),
            companyState: topData[d].company_state,
            hasTop: (topData[d].has_top === true || topData[d].shareholders.length) ? true : false,
            isTopExpanded: false,
            // source: topData[d]
          })
        }
        if (hasEdge(edges, _start, _end) === false) {
          const isClosed = isCompanyClosed(originData.company_state) || isCompanyClosed(topData[d].company_state)
          edges.push({
            start: _start, // 如無uniID使用公司名稱
            end: _end,
            _start, // 因為"start"傳入d3的function之後資料會被渲染，所以多留一份原始資料
            _end, // 因為"end"傳入d3的function之後資料會被渲染，所以多留一份原始資料
            direction: 'top',
            label: isClosed ? '' : returnPercentageText(topData[d].percentage),
            percentage: topData[d].percentage,
            style: {
              path: isClosed ? 'pathClosed' : 'pathTop',
              arrow: isClosed ? 'arrowClosed' : 'arrowTop'
            }
          })
        }
      })
    },
    addTopPersonData (
      originData: ChartCardTypes.RenderDataOrigin,
      topPersonData: ChartCardTypes.RenderDataTopPerson,
      nodes: Array<ChartTypes.ChartNode>,
      edges: Array<ChartTypes.ChartEdge>
    ): void {
      Object.keys(topPersonData).forEach((d, i) => {
        // const id: string = `${originData.uniID}_top-person_${i}`
        let id: string
        // 合併人名選項
        if (this.syncOptions.mergeName && d !== '缺額') {
          id = d // 相同人名視為同樣的key
        } else {
          id = `${originData.uniID}_top-person_${i}`
        }
        const _start = id
        const _end = originData.uniID
        if (hasNode(nodes, id) === false) {
          nodes.push({
            id,
            uniID: '',
            label: d,
            style: 'rectPerson',
            tooltip: '', // 自然人無董兼事/股東資訊可顯示
            companyState: '',
            hasTop: false, // 自然人無上游
            isTopExpanded: false,
            // source: topPersonData[d]
          })
        }
        if (hasEdge(edges, _start, _end) === false) {
          const isClosed = isCompanyClosed(originData.company_state)
          edges.push({
            start: _start,
            end: _end,
            _start, // 因為"start"傳入d3的function之後資料會被渲染，所以多留一份原始資料
            _end, // 因為"end"傳入d3的function之後資料會被渲染，所以多留一份原始資料
            direction: 'top',
            label: isClosed ? '' : returnPercentageText(topPersonData[d].percentage),
            percentage: topPersonData[d].percentage,
            style: {
              path: isClosed ? 'pathClosed' : 'pathTop',
              arrow: isClosed ? 'arrowClosed' : 'arrowTop'
            }
          })
        }
      })
    },
    addDownData (
      originData: ChartCardTypes.RenderDataOrigin,
      downData: ChartCardTypes.RenderDataDown,
      nodes: Array<ChartTypes.ChartNode>,
      edges: Array<ChartTypes.ChartEdge>
    ): void {
      Object.keys(downData).forEach(d => {
        const id = downData[d].uniID || d // 如無uniID使用公司名稱
        const _start = originData.uniID
        const _end = downData[d].uniID || d
        if (hasNode(nodes, id) === false) {
          nodes.push({
            id,
            uniID: downData[d].uniID || '',
            label: d,
            style: isCompanyClosed(downData[d].company_state) ? 'rectCompanyClosed' : 'rectCompanyDown',
            tooltip: returnTooltipText(downData[d].shareholders),
            companyState: downData[d].company_state,
            hasTop: originData.uniID !== this.rootID ? true : false, // 根節點的下層一律為false（不做展開資料的判斷），其餘的皆為有上層資料
            isTopExpanded: false,
            // source: downData[d]
          })
        }
        if (hasEdge(edges, _start, _end) === false) {
          const isClosed = isCompanyClosed(originData.company_state) || isCompanyClosed(downData[d].company_state)
          edges.push({
            start: _start,
            end: _end, // 如無uniID使用公司名稱
            _start, // 因為"start"傳入d3的function之後資料會被渲染，所以多留一份原始資料
            _end, // 因為"end"傳入d3的function之後資料會被渲染，所以多留一份原始資料
            direction: 'down',
            label: isClosed ? '' : returnPercentageText(downData[d].percentage),
            percentage: downData[d].percentage,
            style: {
              path: isClosed ? 'pathClosed' : 'pathDown',
              arrow: isClosed ? 'arrowClosed' : 'arrowDown'
            }
          })
        }
      })
    },
    // // 全部節點的狀態設為展開
    // setAllExpanded(
    //   allNodes: Array<ChartTypes.ChartNode>,
    //   allEdges: Array<ChartTypes.ChartEdge>
    // ): void {
    //   for (let node of allNodes) {
    //     if (node.hasTop === false) {
    //       node.isTopExpanded = false
    //       continue
    //     }
    //     const find = allEdges.find(link => {
    //       return link._end === node.id
    //     })
    //     if (find) {
    //       node.isTopExpanded = true
    //     } else {
    //       node.isTopExpanded = false
    //     }
    //   }
    // },
    // // 全部節點的狀態設為關閉
    // setAllUnexpaned(
    //   allNodes: Array<ChartTypes.ChartNode>,
    //   allEdges: Array<ChartTypes.ChartEdge>
    // ): void {
    //   for (let node of allNodes) {
    //     node.isTopExpanded = false
    //   }
    // },
    modifyHasTopBtnStatus(
      allNodes: Array<ChartTypes.ChartNode>,
      allEdges: Array<ChartTypes.ChartEdge>,
      defaultExpanded
    ): void {
      for (let node of allNodes) {
        // 先假設無上層
        node.hasTop = false
        node.isTopExpanded = false
        // 根節點無展開按鈕
        if (node.id === this.rootID) {
          continue
        }
        let hasTop = allEdges.some(edge => {
          // 非node的上層
          if (edge._end !== node.id) {
            return false
          }
          // 如果上層為根節點則無展開按鈕
          if (edge._start === this.rootID) {
            return false
          }
          // 有上層且非根節點
          return true
        })
        if (hasTop) {
          node.hasTop = true
          node.isTopExpanded = defaultExpanded // 預設是否展開
        }
      }
    },
    modifyDirectionStatus(
      allNodes: Array<ChartTypes.ChartNode>,
      allEdges: Array<ChartTypes.ChartEdge>,
    ): void {
      // 先全部預設為'top'
      for (const edge of allEdges) {
        edge.direction = 'top'
      }
      // 修改direction資料（遞迴）
      let checkedEdge = []
      const modifyDownEdges = (nodeID) => {
        for (const edge of allEdges) {
          if (checkedEdge.find(l => edge._start === l._start && edge._end === l._end)) {
            continue
          }
          if (edge._start === nodeID && edge._end !== this.rootID) { // 要加上edge._end !== this.rootID這個條件，否則同時是根節點的上流及下流的節點也會被誤判為top
            checkedEdge.push(edge)
            edge.direction = 'down'
            // modifyDownEdges(edge._end) // 往下找
          }
        }
      }
      // 從根節點開始往下找
      modifyDownEdges(this.rootID)
    },
    parseNodesData (
      dataSet: ChartCardTypes.RenderData,
      allNodes: Array<ChartTypes.ChartNode>,
      allEdges: Array<ChartTypes.ChartEdge>
    ): {
      allNodes: Array<ChartTypes.ChartNode>;
      allEdges: Array<ChartTypes.ChartEdge>;
    } {
      // 目標公司（初始化時才增加）
      if (allNodes.length < 1) {
        // this.rootID = dataSet.origin.uniID // 紀錄根節點
        this.addOriginData(dataSet.origin, allNodes)
      }
      // 下游法人（如同時為上游也是下游，要優先記錄為下游）
      if (dataSet.down) {
        this.addDownData(dataSet.origin, dataSet.down, allNodes, allEdges)
      }
      // 上游法人
      if (dataSet.top) {
        this.addTopData(dataSet.origin, dataSet.top, allNodes, allEdges)
      }
      // 上游自然人
      if (dataSet.topPerson) {
        this.addTopPersonData(dataSet.origin, dataSet.topPerson, allNodes, allEdges)
      }
      // 是否設定全部節點為展開
      // if (this.allNodesMode === true) {
      //   this.setAllExpanded(allNodes, allEdges)
      // }
      
      return { allNodes, allEdges }
    }
  }
}
